/**
 * @desc 基座入口
 * @time 2023-07-31 15:30:42
 * @user simxin
 */

/**
 * @desc 国际化
 */
import '@src/i18n';

/**
 * @desc 基座样式
 */
import '@src/styles/index.less';

/**
 * @desc 基座依赖
 */
import { mount } from '@src/utils/mount';

/**
 * @desc 页面组件
 */
import { routes } from '@src/routes/index';

/**
 * @desc sea 模块化
 * 基础环境准备后开始加载页面
 */
mount(() => {
  // 先检查是否需要重定向
  routes();
});
